import { IFavoritesView } from '../../trpc/getFavorites'

export const getProductIdsByType = (view: IFavoritesView[], type: string) => {
  const productIds = view
    ?.filter(({ productType }) => productType?.toLowerCase() === type.toLowerCase())
    .map(({ productId }) => productId)

  return productIds?.join(',') ?? ''
}
